import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import {
  ConverterService,
  InterceptorUtil,
  OCC_USER_ID_ANONYMOUS,
  OccEndpointsService,
  USE_CLIENT_TOKEN
} from '@spartacus/core'
import { MbCheckoutAdapter } from '../connectors/checkout'
import { PAYMENT_ORDER_NORMALIZER } from '../converters'

@Injectable({
  providedIn: 'root',
})
export class MbOccCheckoutAdapter implements MbCheckoutAdapter {

  constructor (protected http: HttpClient,
               protected occEndpoints: OccEndpointsService,
               protected converter: ConverterService) {}

  redirectToPaymentPage (userId: string, cartId: string, termsChecked: boolean) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })

    if (userId === OCC_USER_ID_ANONYMOUS) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers)
    }

    const parameters = {
      colorDepth: screen?.colorDepth,
      navigatorJavaEnabled: navigator?.javaEnabled() === undefined ? true : navigator?.javaEnabled(),
      navigatorJavaScriptEnabled: navigator?.javaEnabled() === undefined ? true : navigator?.javaEnabled(),
      screenHeight: window?.screen?.height,
      screenWidth: window?.screen?.width,
      timezoneOffsetUtcMinutes: new Date()?.getTimezoneOffset()
    }

    return this.http.post(this.getPaymentPageEndpoint(userId, cartId, termsChecked.toString()),
      parameters,
        { headers }
      )
  }

  placeOrderWithPayment (userId: string, cartId: string, returnMac: string, hostedCheckoutId: string) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })

    if (userId === OCC_USER_ID_ANONYMOUS) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers)
    }

    return this.http.post(this.getPlaceOrderWithPaymentEndpoint(userId, cartId, returnMac, hostedCheckoutId),
      {},
      { headers }
    ).pipe(this.converter.pipeable(PAYMENT_ORDER_NORMALIZER))
  }

  resetIngenicoPayment (userId: string, cartId: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })

    return this.http.post(this.getResetIngenicoPaymentEndpoint(userId, cartId),
      {},
      { headers }
    )
  }

  protected getPaymentPageEndpoint (userId: string, cartId: string, termsChecked: string) {
    return this.occEndpoints.buildUrl('hostedCheckoutPaymentPage', {
      urlParams: { userId },
      queryParams: { cartId, termsChecked },
    })
  }

  protected getPlaceOrderWithPaymentEndpoint (
    userId: string,
    cartId: string,
    returnMac: string,
    hostedCheckoutId: string) {
    return this.occEndpoints.buildUrl('placeOrderHostedCheckout', {
      urlParams: { userId: userId },
      queryParams: { cartId: cartId, RETURNMAC: returnMac, hostedCheckoutId: hostedCheckoutId },
    })
  }

  protected getResetIngenicoPaymentEndpoint (userId: string, cartId: string) {
    return this.occEndpoints.buildUrl('resetIngenicoPayment', {
      urlParams: { userId: userId, cartId: cartId },
    })
  }
}
